export const SURVEYTEMPLATEDETAIL_LOADING = "SURVEYTEMPLATEDETAIL_LOADING";
export const SURVEYTEMPLATEDETAIL_RESET = "SURVEYTEMPLATEDETAIL_RESET";
export const GET_SURVEYTEMPLATEDETAIL = "GET_SURVEYTEMPLATEDETAIL";
export const GET_SURVEYTEMPLATEDETAIL_SUCCESS =
  "GET_SURVEYTEMPLATEDETAIL_SUCCESS";
export const GET_SURVEYTEMPLATEDETAIL_FAIL = "GET_SURVEYTEMPLATEDETAIL_FAIL";
export const DELETE_SURVEYTEMPLATEDETAIL = "DELETE_SURVEYTEMPLATEDETAIL";
export const DELETE_SURVEYTEMPLATEDETAIL_SUCCESS =
  "DELETE_SURVEYTEMPLATEDETAIL_SUCCESS";
export const DELETE_SURVEYTEMPLATEDETAIL_FAIL =
  "DELETE_SURVEYTEMPLATEDETAIL_FAIL";
export const UPDATE_SURVEYTEMPLATEDETAIL = "UPDATE_SURVEYTEMPLATEDETAIL";
export const UPDATE_SURVEYTEMPLATEDETAIL_SUCCESS =
  "UPDATE_SURVEYTEMPLATEDETAIL_SUCCESS";
export const UPDATE_SURVEYTEMPLATEDETAIL_FAIL =
  "UPDATE_SURVEYTEMPLATEDETAIL_FAIL";
export const ADD_NEW_SURVEYTEMPLATEDETAIL = "ADD_NEW_SURVEYTEMPLATEDETAIL";
export const ADD_SURVEYTEMPLATEDETAIL_SUCCESS =
  "ADD_SURVEYTEMPLATEDETAIL_SUCCESS";
export const ADD_SURVEYTEMPLATEDETAIL_FAIL = "ADD_SURVEYTEMPLATEDETAIL_FAIL";
export const SURVEYTEMPLATEDETAIL_RESET_CREATE =
  "SURVEYTEMPLATEDETAIL_RESET_CREATE";
